export default "__VITE_ASSET__Cd17qX2i__"